import styled from 'styled-components';

export const PerformanceRatchetTiersListStyles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	.add-button {
		margin-right: auto;
	}
`;
